
const anchor = document.querySelectorAll('.js-scroll');

anchor.forEach((trigger) => {
  trigger.onclick = function anchorHandler (e) {
    e.preventDefault();
    const hash = this.getAttribute('href');
    const target = document.querySelector(hash);
    const elementPosition = target.offsetTop;
    const offsetPosition = elementPosition - 185; // 185 is the height of the info bar

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };
});
